var map = {
	"./easy.png": 2939,
	"./hard.png": 2940,
	"./onlevel.png": 2941
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;



//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/reading-levels .\.png*
// module id = 376
// module chunks = 0